import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ff7fb006&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=ff7fb006&scoped=true&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=ff7fb006&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7fb006",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff7fb006')) {
      api.createRecord('ff7fb006', component.options)
    } else {
      api.reload('ff7fb006', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ff7fb006&scoped=true&", function () {
      api.rerender('ff7fb006', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/knowledgeBaseMgr/knowledgeSearch/index.vue"
export default component.exports